export default __webpack_public_path__ + "static/img/src/components/Icon/Ellipse.svg";